import React from "react";
const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const Jobs = ({ plans }) => {
  return (
    <>
      {plans.length > 0 ? (
        <table className="plan_table mt-24">
          <thead className="plan_thead">
            <tr className="plan_thead_tr plan_tr">
              <th className="plan_thead_tr plan_td">Job Name</th>
              <th className="plan_thead_tr plan_td">Job Schedule</th>
              <th className="plan_thead_tr plan_td">Job Status</th>
              <th className="plan_thead_tr plan_td">User</th>
              <th className="plan_thead_tr plan_td">Type</th>
              <th className="plan_thead_tr plan_td">Profile Status</th>
            </tr>
          </thead>
          <tbody className="plan_tbody">
            {plans.map((plan) => (
              <tr key={plan._id} className="plan_tbody_tr plan_tr">
                <td className="plan_tbody_td plan_td">{plan.name}</td>
                <td
                  style={
                    plan.status === "stopped"
                      ? { color: "green" }
                      : plan.status === "delayed"
                      ? { color: "skyblue" }
                      : { color: "red" }
                  }
                  className="plan_tbody_td plan_td"
                >
                  {plan.type === "repeating" ? (
                    <>
                      <ul>Last run at {returnDate(plan.lastRunAt)}</ul>
                      <ul style={{ color: "green" }}>
                        Next run at{" "}
                        {returnDate(
                          plan.name === "zefyron-updates"
                            ? new Date(plan.lastRunAt).setDate(
                                new Date(plan.lastRunAt).getDate() + 14
                              )
                            : new Date(plan.nextRunAt)
                        )}
                      </ul>
                    </>
                  ) : (
                    <>
                      {plan.status === "stopped"
                        ? `Job ran success at ${returnDate(plan.startDate)}`
                        : plan.status === "delayed"
                        ? `Scheduled at  ${returnDate(plan.startDate)}`
                        : `Failed Job Scheduled at ${returnDate(
                            plan.startDate
                          )}`}
                    </>
                  )}
                </td>

                <td className="plan_tbody_td plan_td">{plan.status}</td>
                <td className="plan_tbody_td plan_td">
                  <div className="d-flex plan_tbody_logo align-items-center">
                    {plan.user ? (
                      <>
                        <img src={plan?.user?.avatar} alt="logo" />
                        <div>
                          <p className="m-0">
                            {plan?.user?.name
                              ? plan?.user?.name
                              : `${plan?.user?.firstname} ${plan?.user?.lastname}`}
                          </p>
                          <p className="m-0 mt-8">{`${plan?.user?.email}`}</p>
                        </div>
                      </>
                    ) : plan.event ? (
                      <>
                        <img src={plan?.event?.thumbnail} alt="logo" />
                        <div>
                          <p className="m-0">
                            {plan?.event?.title} on{" "}
                            {returnDate(plan.event?.eventUTCtime)}
                          </p>
                          <p className="m-0 mt-8">{`${plan?.event?.hostCompany}`}</p>
                        </div>
                      </>
                    ) : (
                      "Not Found"
                    )}
                  </div>
                </td>
                <td className="plan_tbody_td plan_td">{plan?.user?.type}</td>
                <td className="plan_tbody_td plan_td">
                  {(plan.user?.type === "member" &&
                    plan.user?.isEmailVerified) ||
                  plan?.user?.isProfileVerified
                    ? "Verified"
                    : "Not Verified"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <h2>No Jobs</h2>
      )}
    </>
  );
};

export default Jobs;
